/** cx: join class names, skipping falsy ones. */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(" ");
}

/** The kit's focus ring: a solid 3 px ring in the ring colour (4.5:1 on white, 4.0:1 on the desk, 3.3:1 against the dark fill), on keyboard focus only. */
export const focusRing = "outline-none focus-visible:ring-[3px] focus-visible:ring-ring";

/**
 * Content kept on screen while what replaces it loads (useQuery's `stale`): it dims, then comes back to full as the
 * new content lands, one 200 ms fade each way. Never a skeleton, never a blank (#714). No fade under reduced motion.
 */
export const staleFade = (stale: boolean): string => cx("transition-opacity duration-200 ease-out motion-reduce:transition-none", stale && "opacity-60");
